export const ROLES = {
  LAWYER: 'lawyer',
  MEDICAL: 'medical',
  CLIENT: 'client',
};

export const APPOINTMENT_TYPES = {
  consultation: { label: 'Legal Consultation', color: '#3B82F6', icon: 'Scale' },
  medical_exam: { label: 'Medical Examination', color: '#EF4444', icon: 'Stethoscope' },
  followup: { label: 'Follow-Up', color: '#223368', icon: 'RefreshCw' },
  deposition: { label: 'Deposition', color: '#F59E0B', icon: 'FileText' },
  ime: { label: 'IME', color: '#EC4899', icon: 'ClipboardCheck' },
  therapy: { label: 'Physical Therapy', color: '#10B981', icon: 'Activity' },
  mediation: { label: 'Mediation', color: '#06B6D4', icon: 'Scale' },
  court_hearing: { label: 'Court Hearing', color: '#DC2626', icon: 'Gavel' },
  other: { label: 'Other', color: '#6B7280', icon: 'Calendar' },
};

export const STATUSES = {
  confirmed: { label: 'Confirmed', color: '#10B981' },
  pending: { label: 'Pending', color: '#F59E0B' },
  completed: { label: 'Completed', color: '#6B7280' },
  cancelled: { label: 'Cancelled', color: '#EF4444' },
  no_show: { label: 'No Show', color: '#DC2626' },
  rescheduled: { label: 'Rescheduled', color: '#223368' },
  reschedule_requested: { label: 'Reschedule Requested', color: '#D946EF' },
};

const today = new Date();
const d = (offset, h, m) => {
  const date = new Date(today);
  date.setDate(date.getDate() + offset);
  date.setHours(h, m, 0, 0);
  return date;
};

export const mockStaff = [
  { id: 's1', name: 'Atty. Sarah Mitchell', role: ROLES.LAWYER, avatar: 'SM', specialty: 'Personal Injury' },
  { id: 's2', name: 'Atty. James Park', role: ROLES.LAWYER, avatar: 'JP', specialty: 'Litigation' },
  { id: 's3', name: 'Dr. Maria Santos', role: ROLES.MEDICAL, avatar: 'MS', specialty: 'Orthopedics' },
  { id: 's4', name: 'Dr. Kevin Liu', role: ROLES.MEDICAL, avatar: 'KL', specialty: 'Neurology' },
  { id: 's5', name: 'PT Rachel Green', role: ROLES.MEDICAL, avatar: 'RG', specialty: 'Physical Therapy' },
];

export const mockClients = [
  { id: 'c1', name: 'Michael Johnson', caseNumber: 'PI-2026-0142', injury: 'Lumbar herniation — MVA' },
  { id: 'c2', name: 'Angela Torres', caseNumber: 'PI-2026-0158', injury: 'Rotator cuff tear — Slip & fall' },
  { id: 'c3', name: 'David Kim', caseNumber: 'PI-2026-0163', injury: 'TBI — Pedestrian accident' },
  { id: 'c4', name: 'Lisa Patel', caseNumber: 'PI-2026-0171', injury: 'Cervical radiculopathy — Rear-end collision' },
  { id: 'c5', name: 'Robert Chen', caseNumber: 'PI-2026-0180', injury: 'Knee meniscus tear — Workplace fall' },
];

export const mockAppointments = [
  {
    id: 'a1',
    type: 'consultation',
    client: mockClients[0],
    staff: mockStaff[0],
    start: d(0, 9, 0),
    end: d(0, 10, 0),
    status: 'confirmed',
    location: 'Office — Room 201',
    notes: 'Initial case review. Bring all accident documentation.',
  },
  {
    id: 'a2',
    type: 'medical_exam',
    client: mockClients[1],
    staff: mockStaff[2],
    start: d(0, 10, 30),
    end: d(0, 11, 30),
    status: 'confirmed',
    location: 'Medical Suite A',
    notes: 'Shoulder MRI follow-up. Pre-surgical evaluation.',
  },
  {
    id: 'a3',
    type: 'therapy',
    client: mockClients[4],
    staff: mockStaff[4],
    start: d(0, 13, 0),
    end: d(0, 14, 0),
    status: 'pending',
    location: 'PT Clinic — Bay 3',
    notes: 'Session 8 of 12. Focus on range of motion.',
  },
  {
    id: 'a4',
    type: 'deposition',
    client: mockClients[2],
    staff: mockStaff[1],
    start: d(0, 14, 30),
    end: d(0, 16, 0),
    status: 'confirmed',
    location: 'Conference Room B',
    notes: 'Defense deposition. Videographer confirmed.',
  },
  {
    id: 'a5',
    type: 'followup',
    client: mockClients[3],
    staff: mockStaff[3],
    start: d(1, 9, 0),
    end: d(1, 9, 45),
    status: 'confirmed',
    location: 'Neurology Clinic',
    notes: 'Post-concussion symptom check. Bring headache diary.',
  },
  {
    id: 'a6',
    type: 'consultation',
    client: mockClients[4],
    staff: mockStaff[0],
    start: d(1, 11, 0),
    end: d(1, 12, 0),
    status: 'pending',
    location: 'Office — Room 201',
    notes: 'Settlement discussion. Updated demand letter review.',
  },
  {
    id: 'a7',
    type: 'medical_exam',
    client: mockClients[0],
    staff: mockStaff[2],
    start: d(2, 10, 0),
    end: d(2, 11, 0),
    status: 'confirmed',
    location: 'Medical Suite A',
    notes: 'Lumbar re-evaluation. 6-month post-accident.',
  },
  {
    id: 'a8',
    type: 'therapy',
    client: mockClients[1],
    staff: mockStaff[4],
    start: d(2, 14, 0),
    end: d(2, 15, 0),
    status: 'confirmed',
    location: 'PT Clinic — Bay 1',
    notes: 'Post-surgical rehab session 2. Gentle mobilization.',
  },
  {
    id: 'a9',
    type: 'deposition',
    client: mockClients[3],
    staff: mockStaff[1],
    start: d(3, 10, 0),
    end: d(3, 12, 0),
    status: 'pending',
    location: 'Conference Room A',
    notes: 'Plaintiff deposition. Prepare client beforehand.',
  },
  {
    id: 'a10',
    type: 'consultation',
    client: mockClients[2],
    staff: mockStaff[0],
    start: d(4, 15, 0),
    end: d(4, 16, 0),
    status: 'confirmed',
    location: 'Office — Room 201',
    notes: 'Case strategy meeting with family.',
  },
  {
    id: 'a11',
    type: 'followup',
    client: mockClients[0],
    staff: mockStaff[3],
    start: d(-1, 11, 0),
    end: d(-1, 11, 45),
    status: 'completed',
    location: 'Neurology Clinic',
    notes: 'EMG/NCV results review. Referred to pain management.',
  },
  {
    id: 'a12',
    type: 'therapy',
    client: mockClients[4],
    staff: mockStaff[4],
    start: d(-2, 13, 0),
    end: d(-2, 14, 0),
    status: 'completed',
    location: 'PT Clinic — Bay 3',
    notes: 'Session 7. Good progress on extension.',
  },
  {
    id: 'a13',
    type: 'medical_exam',
    client: mockClients[3],
    staff: mockStaff[2],
    start: d(-1, 9, 0),
    end: d(-1, 10, 0),
    status: 'no_show',
    location: 'Medical Suite A',
    notes: 'Patient did not appear. Reschedule required.',
  },
];
